import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";
import { ComponentModal, TitleComponents } from "../common/interfaces";

interface ModalAction {
  closeModal: () => void;
  openModal: (by?: ComponentModal, data?: Record<string, any>) => void;
  setTitle: (by: TitleComponents | string) => void;
  setComponent: (componentName?: ComponentModal, params?: Record<string, any>) => void;
}



export interface IModal {
  title: TitleComponents | string;
  open: boolean;
  component: ComponentModal | "";
  params?: Record<string, any>;
  data?: Record<string, any>;
}

const initialState: IModal = {
  title: TitleComponents.Customer,
  open: false,
  component: "",
  params: {},
  data: {},
};

export const useModalStore = create<IModal & ModalAction>()(
  devtools(
    persist(
      (set, get) => ({
        ...initialState,
        closeModal: () => set({ ...get(), open: false, params: {}, data: {} }),
        openModal: (componentName?: ComponentModal, data?: Record<string, any>) => {
          if (componentName) {
            console.log('🔍 MODAL STORE - Opening modal:', {
              componentName,
              data,
              dataOrder: data?.order,
              dataOrderTotal: data?.order?.total,
            });
            set({
              ...get(),
              component: componentName,
              open: true,
              params: data ?? {},
            });
            return;
          }
          set({ ...get(), open: true });
        },
        setTitle: (title: TitleComponents | string) => set({ ...get(), title: title }),
        setComponent: (componentName?: ComponentModal, params?: Record<string, any>) => set({ ...get(), component: componentName, params: {...get().params, ...params} }),
      }),
      {
        name: "pos-modal-status",
      }
    )
  )
);
